// removed by extract-text-webpack-plugin
module.exports = {"searchInput":"styles__searchInput___1rY7_"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/searchInput/styles.css
// module id = 2UM/
// module chunks = 2